import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Truck, CheckCircle2, Circle, Award } from "lucide-react";
import api from "@/lib/api";

export default function Suppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [perf, setPerf] = useState([]);

  useEffect(() => {
    api.get("/admin/suppliers").then((r) => setSuppliers(r.data));
    api.get("/admin/suppliers/performance").then((r) => setPerf(r.data));
  }, []);

  return (
    <div className="space-y-5">
      <div><h1 className="font-display text-2xl font-bold tracking-tight">Suppliers</h1><p className="text-sm text-zinc-500">Multi-supplier gateway · adapter architecture</p></div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {suppliers.map((s) => (
          <div key={s.key} className="bg-white border border-zinc-200 rounded-xl p-5" data-testid={`supplier-${s.key}`}>
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-zinc-900 text-white w-10 h-10 rounded-lg flex items-center justify-center"><Truck size={18} /></div>
                <div><p className="font-semibold">{s.name}</p><p className="text-xs text-zinc-400 font-mono">{s.key}</p></div>
              </div>
              {s.connected ? <span className="flex items-center gap-1 text-xs text-green-600 font-medium"><CheckCircle2 size={14} />Connected</span>
                : <span className="flex items-center gap-1 text-xs text-zinc-400"><Circle size={14} />Not connected</span>}
            </div>
            <div className="flex justify-between text-xs text-zinc-500 mt-4 pt-4 border-t border-zinc-100">
              <span>{s.product_count} products</span>
              <Link to="/admin/integrations" className="text-blue-600 font-medium">Configure API →</Link>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-zinc-200 rounded-xl p-5">
        <h3 className="font-semibold text-sm mb-4 flex items-center gap-2"><Award size={16} />Supplier Performance</h3>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-zinc-500 border-b border-zinc-100">
            <th className="pb-2 font-medium">Supplier</th><th className="pb-2 font-medium">Orders</th>
            <th className="pb-2 font-medium">Shipped</th><th className="pb-2 font-medium">Avg Fulfillment</th>
            <th className="pb-2 font-medium">Stock Reliability</th><th className="pb-2 font-medium">Score</th>
          </tr></thead>
          <tbody>
            {perf.map((p) => (
              <tr key={p.key} className="border-b border-zinc-50">
                <td className="py-2.5 font-medium">{p.supplier}</td>
                <td className="py-2.5">{p.total_orders}</td>
                <td className="py-2.5">{p.shipped}</td>
                <td className="py-2.5">{p.avg_fulfillment_days}d</td>
                <td className="py-2.5">{p.stock_reliability}%</td>
                <td className="py-2.5"><span className="font-semibold text-green-600">{p.score}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
